<template>
  <div class="releaseWish">
    <div class="container release">
      <!-- 输入框 -->
      <div class="textarea_section">
        <van-field
          v-model="content"
          type="textarea"
          placeholder="请输入内容"
          autosize
          :border="false"
          maxlength="200"
          show-word-limit
        />
      </div>
      <!-- 图片视频上传区域 -->
      <div class="upload_section">
        <van-uploader
          v-model="fileList"
          max-count="12"
          multiple
          preview-full-image
        >
          <div class="upload_img">
            <img src="http://img.wish.hebyun.com.cn/images/upload_add.png" />
          </div>
        </van-uploader>
      </div>
      <!-- 地区 方向选择区域 -->
      <div class="choices_section">
        <!-- 地区 -->
        <div class="choice">
          <div class="choice_left">
            <van-icon name="location" color="#666" size="12px" />
            <span>地区</span>
          </div>
          <div class="choice_right" @click="showAreaPopup">
            <input
              type="text"
              placeholder="请选择地区"
              :value="address"
              disabled
            />
            <van-icon name="arrow" size="16px" color="#333" />
          </div>
        </div>
        <!-- 方向 -->
        <div class="choice">
          <div class="choice_left">
            <img
              class="choice_left_direction"
              src="http://img.wish.hebyun.com.cn/images/direction.png"
            />
            <span>方向</span>
          </div>
          <div class="choice_right" @click="showPopup">
            <input
              type="text"
              :value="direction"
              placeholder="请选择心愿方向"
              disabled
            />
            <van-icon name="arrow" size="16px" color="#333" />
          </div>
        </div>
      </div>
      <!-- 底部区域 -->
      <div class="footer">
        <Button :button="button" @click.native="publishBtn" />

        <Checkbox @changeState="change($event)">
          <div class="terms_texts" slot="checkText">
            <span class="terms_gray">我已阅读并同意</span>
            <span class="terms_red" @click="jumpProtocol">《隐私条款》</span>
            <span class="terms_gray">与</span>
            <span class="terms_red" @click="jumpProtocol">《免责声明》</span>
          </div>
        </Checkbox>
      </div>
      <!--地区弹出层-->
      <van-popup v-model="showAreaPop" round position="bottom">
        <van-picker
          title="地区"
          show-toolbar
          value-key="name"
          :columns="region"
          @confirm="handleAreaConfirm"
          @cancel="handleAreaCancle"
        />
      </van-popup>
      <!--心愿弹出层-->
      <van-popup v-model="showPop" round position="bottom">
        <van-picker
          title="心愿方向"
          show-toolbar
          value-key="name"
          :columns="category"
          @confirm="handleConfirm"
          @cancel="handleCancle"
        />
      </van-popup>
      <!-- Loading -->
      <van-overlay :show="showLoading">
        <van-loading type="spinner" />
      </van-overlay>
    </div>
    <div class="side_bars">
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        v-if="isFirstPage"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Checkbox from "@/components/Checkbox";

export default {
  name: "release",
  components: {
    Button,
    Checkbox,
  },
  data() {
    return {
      showLoading: false, //loading
      category: [], //心愿方向
      region: [], //地区
      categoryid: "", //心愿方向id
      button: "发布",
      show: false,
      content: "",
      fileList: [],
      city: "", //城市
      area: "", //区县
      address: "",
      direction: "",
      showPop: false,
      showAreaPop: false,
      checked: true,
       isFirstPage: false,  
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/protocol") {
      //判断是从哪个路由过来的，若是protocol页面不需要刷新获取新数据，直接用之前缓存的数据即可
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
      this.content = "";
      this.city = "";
      this.area = "";
      this.address = "";
      this.direction = "";
      this.wish_content = ""; //心愿内容;
      this.categoryid = ""; //完成内容;
      this.category = []; // 心愿图片
      this.region = []; //完成图片
      this.querySort();
      this.queryRegion();
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
    // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false;
  },
  created() {},
  mounted() {
    this.querySort();
    this.queryRegion();
  },
  methods: {
    // 查询地区
    async queryRegion() {
      let { data } = await this.$api.queryLevelRegion();
      this.region = data;
    },

    //心愿方向
    async querySort() {
      let { data } = await this.$api.queryWishSort();
      this.category = data.category;
    },

    showPopup() {
      this.showPop = true;
    },
    showAreaPopup() {
      this.showAreaPop = true;
    },
    handleCancle() {
      this.showPop = false;
    },
    handleAreaCancle() {
      this.showAreaPop = false;
    },
    handleAreaConfirm(e) {
      this.address = e[0] + "·" + e[1];
      this.city = e[0];
      this.area = e[1];
      this.showAreaPop = false;
    },
    handleConfirm(e) {
      this.direction = e.name;
      this.categoryid = e.id;
      this.showPop = false;
    },
    // 接收复选框状态
    change(data) {
      console.log(data);
      this.checked = data;
    },
    // 点击隐私条款
    jumpProtocol() {
      this.$router.push("./protocol");
    },
    // 发布按钮
    async publishBtn() {
      if (this.content.trim().length === 0) {
        this.$toast("内容不能为空");
        return;
      }
      if (this.address.trim().length === 0) {
        this.$toast("请选择地区");
        return;
      }
      if (this.direction.trim().length === 0) {
        this.$toast("请选择心愿方向");
        return;
      }
      if (this.checked === false) {
        this.$toast("请您勾选下方复选框");
        return;
      }
      this.showLoading = true;
      let token = localStorage.getItem("uploadToken");
      let fileList = [];

      if (this.fileList.length != 0) {
        fileList = await this.$api.uploadFile(this.fileList, token);
        fileList = JSON.stringify(fileList);
     
      }

      console.log(fileList);
      let data = {
        content: this.content,
        categoryid: this.categoryid,
        city: this.city,
        area: this.area,
        imgs: fileList, //数组json字符串
      };

      console.log(data,"15")

     this.$api.publishWish(data);
      this.showLoading = false;
      this.$toast("发布成功");
      
      setTimeout(() => {
        this.$router.push("./mine");
      }, 1000);
   
 
    },
  },
};
</script>
<style lang="scss">
.releaseWish .footer .btn {
  position: static;
  margin-top: 160px;
  width: 210px !important;
  height: 36px !important;
}

.releaseWish .checkbox {
  position: static;
  width: 100%;
  /deep/.van-checkbox {
    display: flex;
    align-items: center;
  }
  /deep/.van-checkbox__label {
    margin-left: 2px;
    line-height: 1;
  }
}
.releaseWish .side_bars {
  bottom: 130px;
}
</style>
<style scoped lang="scss">
.releaseWish {
  .release {
    padding: 9px 15px;
    width: 100%;
    box-sizing: border-box;
    /deep/ .van-cell {
      height: 100%;
      padding: 10px;
    }
    /* 输入框 */
    .textarea_section {
      position: relative;
      width: 344.5px;
      height: 170.5px;
      background-color: #ffffff;
      border-radius: 10px;
      font-size: 13px;
      line-height: 1.4;
      color: #999999;
      overflow: hidden;
      margin-bottom: 10px;
      /deep/ .van-field__body {
        height: 90%;
        .van-field__control {
          height: 100% !important;
        }
      }
      .textarea_section_nums {
        position: absolute;
        display: flex;
        right: 10px;
        bottom: 13.5px;
        text {
          font-size: 11px;
          color: #999999;
        }
      }
    }
    /* 图片视频上传区域 */
    .upload_section {
      width: 100%;
      margin-bottom: 16px;
      min-height: 86px;
      /deep/.van-uploader {
        display: block;
      }
      /deep/.van-uploader__preview-delete {
        width: 15px;
        height: 15px;
        right: -5px;
        top: -5px;
        border-radius: 50%;
        .van-uploader__preview-delete-icon {
          right: -1px;
          top: 0px;
        }
      }
      /deep/.van-uploader__preview-image {
        position: relative;
        width: 78px;
        height: 78px;
        background-color: #ffffff;
        border-radius: 6px;
      }
      .upload_img {
        position: relative;
        width: 78px;
        height: 78px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    /* 地区 方向选择区域  */
    .choices_section {
      width: 100%;
      .choice {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(230, 0, 18, 0.1);
        padding-bottom: 10px;
        padding-top: 10px;
        .choice_left {
          display: flex;
          align-items: center;
          span {
            font-size: 14px;
            color: #333333;
            margin-left: 6px;
          }
          .choice_left_direction {
            width: 10px;
            height: 9.5px;
          }
        }
        .choice_right {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          input {
            text-align: right;
            font-size: 13px;
            color: #000000;
            border: none;
            background-color: transparent;
          }
        }
      }
    }
    /* 底部区域 */
    .footer {
      .terms_texts {
        display: flex;
        align-items: center;
        .terms_gray {
          font-size: 11px;
          color: #999999;
        }
        .terms_red {
          font-size: 11px;
          color: #e60012;
        }
      }
    }
  }
  /deep/.van-picker__title {
    line-height: normal;
  }
}
</style>
